import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';
import { getAction } from '../../../appconfig/AppHelper';

export const ReminderTab = (initialTabLabel: any) => {
    const router = useNavigate();

    const [actions, setActions] = useState<any>([]);

    const HRitems: MenuItem[] = [
        {
            label: 'Reminder To College',
            command: () => {
                router('/app/letters/reminder-college-letter');
            }
        },
        {
            label: 'Reminder To School',
            command: () => {
                router('/app/letters/reminder-school-letter');
            }
        },
        {
            label: 'Reminder To Council',
            command: () => {
                router('/app/letters/reminder-council');
            }
        },
        {
            label: 'Reminder To Hospital',
            command: () => {
                router('/app/letters/reminder-hospital');
            }
        },
        {
            label: 'Reminder To Medical',
            command: () => {
                router('/app/letters/reminder-medical');
            }
        },
        {
            label: 'Reminder To University',
            command: () => {
                router('/app/letters/reminder-university');
            }
        },
        {
            label: 'Reminder To Board',
            command: () => {
                router('/app/letters/reminder-board');
            }
        },
        {
            label: 'Reminder To NIOS',
            command: () => {
                router('/app/letters/reminder-nios');
            }
        },
        {
            label: 'Reminder To RHUS',
            command: () => {
                router('/app/letters/reminder-ruhs');
            }
        }
    ];

    const [activeIndex, setActiveIndex] = useState<number>(0);

    const filteredHRitems = HRitems.filter((item) => item.label && Object.prototype.hasOwnProperty.call(actions, item.label));

    // use Effect method
    useEffect(() => {
        setActions(getAction('Reminder Letters'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        if (filteredHRitems.length > 0 && initialTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label == initialTabLabel.initialTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [actions, filteredHRitems]);

    return (
        <>
            <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab inner-tab " />
        </>
    );
};
